import { Link } from 'react-router-dom'
import './Header.css';
import headerData from '../Data/Header.json';
import { FaTruck, FaChevronDown, FaChevronUp, FaPhoneAlt, FaBars, FaTimes } from "react-icons/fa";
import { NavLink, useLocation } from 'react-router-dom';
import { useState, useEffect, useLayoutEffect, useRef } from 'react';

// hover opens "Our Projects" only on devices with a real mouse; touch uses tap
const canHover = () => window.matchMedia('(hover: hover)').matches;

export default function Header() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const topRef = useRef(null);
  const location = useLocation();

  // The header is fixed: keep the page offset (--header-h) equal to its real height at every width
  useLayoutEffect(() => {
    const el = topRef.current;
    const update = () =>
      document.documentElement.style.setProperty('--header-h', `${Math.ceil(el.getBoundingClientRect().height)}px`);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  // close the mobile menu after navigating
  useEffect(() => {
    setMenuOpen(false);
    setShowDropdown(false);
  }, [location.pathname]);

  const linkClass = ({ isActive }) => (isActive ? 'headings active-link' : 'headings');

  return (
    <div className='top-section' ref={topRef}>
      <header className='header'>
        {/* Left - Logo */}
        <div className='header-left'>
          <Link
            to='/'
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <img
              src={process.env.PUBLIC_URL + headerData.logo.src}
              alt={headerData.logo.alt}
              className='logo'
            />
          </Link>
        </div>

        {/* Center - Menu (a drop-down panel on phones) */}
        <nav className={menuOpen ? 'header-center open' : 'header-center'} id='main-menu'>
          <NavLink to='/about' className={linkClass}>
            About Us
          </NavLink>

          <NavLink to='/products' className={linkClass}>
            Products
          </NavLink>

          <NavLink to='/catalogue' className={linkClass}>
            Catalogue
          </NavLink>

          <div
            className='dropdown-wrapper'
            onMouseEnter={() => canHover() && setShowDropdown(true)}
            onMouseLeave={() => canHover() && setShowDropdown(false)}
          >
            <button
              type='button'
              className='headings dropdown-toggle'
              aria-expanded={showDropdown}
              onClick={() => setShowDropdown(!showDropdown)}
            >
              Our Projects{' '}
              {showDropdown ? (
                <FaChevronUp size={12} />
              ) : (
                <FaChevronDown size={12} />
              )}
            </button>
            {showDropdown && (
              <div className='dropdown-menu'>
                <NavLink to='/projects/wallpapers' className='dropdown-item'>
                  Wallpapers
                </NavLink>
                <NavLink to='/projects/blinds' className='dropdown-item'>
                  Blinds
                </NavLink>
                <NavLink to='/projects/curtains' className='dropdown-item'>
                  Curtains
                </NavLink>
                <NavLink to='/projects/upholstery' className='dropdown-item'>
                  Upholstery
                </NavLink>
              </div>
            )}
          </div>

          <NavLink to='/contact' className={linkClass}>
            Contact Us
          </NavLink>
        </nav>

        {/* Right - Contact (tap to call on phones) */}
        <a className='header-right' href='tel:+919494767687' aria-label='Call +91 94947 67687'>
          <span className='contact-number'>
            <span className='icon-wrap'>
              <FaPhoneAlt />
            </span>
            <span className='contact-divider'></span>
            <span className='contact-text'>+91 94947 67687</span>
          </span>
        </a>

        <button
          type='button'
          className='menu-toggle'
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls='main-menu'
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </header>
      <div className='shipping-banner'>
        <h2>
          FREE SHIPPING & INSTALLATION <FaTruck className='shipping-icon' />
        </h2>
      </div>
    </div>
  );
}
